<template>
  <b-modal
    title="First Withdrawal Verification"
    hide-footer
    centered
    size="md"
    id="first-withdrawal-modal"
  >
    <div
      class="p-1 rounded text-center text-black"
      style="background: #fff4d6; border: 1px solid #f3d99f"
    >
      <p class="font-weight-bold">
        <feather-icon icon="InfoIcon" size="20" class="mr-1 text-warning" />
        First Withdrawal Pending Verification
      </p>

      <span>
        Enter comments and mark as verified once documents have been received
        and validated.
      </span>
    </div>

    <!-- COMMENTS -->
    <p class="font-weight-bold text-black mt-2">Comments / Notes</p>

    <b-form-textarea
      v-model="comments"
      rows="4"
      placeholder="Enter verification notes, licence details, or any relevant comments..."
    ></b-form-textarea>

    <p class="text-muted small my-0 text-center">
      Document any verification steps taken, licence number verified, or other
      relevant information.
    </p>

    <!-- CHECKBOX -->
    <b-form-checkbox v-model="docsVerified" class="mt-1">
      <span class="font-weight-bold"> Documents received and verified</span>
    </b-form-checkbox>

    <hr class="my-1" />

    <!-- FOOTER BUTTONS -->
    <div class="d-flex justify-content-end">
      <b-button variant="light" class="mr-2" @click="hideModal">
        Cancel
      </b-button>

      <b-button variant="dark" class="" @click="markVerified">
        <feather-icon icon="CheckIcon" /> Mark as Verified
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BFormTextarea,
  BFormCheckbox,
  BIcon,
} from "bootstrap-vue";
export default {
  components: {
    BModal,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    BIcon,
  },
  data() {
    return {
      comments: "",
      docsVerified: false,
    };
  },
  methods: {
    markVerified() {
      this.hideModal();
    },
    hideModal() {
      this.$$bvModal.hide("first-withdrawal-modal");
    },
  },
};
</script>